import React from 'react';

/* Sub Heading*/
const SubHeading = ({ subHeading, classes = '' }) => {
  return <p className={'max-w-4xl mb-0 text-gray-700 ' + (classes ? classes : 'mt-2 text-xs leading-relaxed')}>{subHeading}</p>;
};

export default SubHeading;
